import * as React from 'react';
import MuiAvatar from '@mui/material/Avatar';
import MuiListItemAvatar from '@mui/material/ListItemAvatar';
import MenuItem from '@mui/material/MenuItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListSubheader from '@mui/material/ListSubheader';
import Select, {SelectChangeEvent, selectClasses} from '@mui/material/Select';
import Divider from '@mui/material/Divider';
import { styled } from '@mui/material/styles';
import AddRoundedIcon from '@mui/icons-material/AddRounded';
import DevicesRoundedIcon from '@mui/icons-material/DevicesRounded';
import SmartphoneRoundedIcon from '@mui/icons-material/SmartphoneRounded';
import ConstructionRoundedIcon from '@mui/icons-material/ConstructionRounded';
import axios, { all } from "axios";
import dayjs from "dayjs";
import {useEffect} from "react";
import Grid from "@mui/material/Grid2";
import StatCard from "./StatCard";
import ActorStatCard from "./ActorStatCard";
import {useDropzone} from "react-dropzone";
import {useNavigate} from "react-router-dom";
import { useGrowSetup } from '../GrowSetupContext';



const Avatar = styled(MuiAvatar)(({ theme }) => ({
  width: 28,
  height: 28,
  backgroundColor: (theme.vars || theme).palette.background.paper,
  color: (theme.vars || theme).palette.text.secondary,
  border: `1px solid ${(theme.vars || theme).palette.divider}`,
}));

const ListItemAvatar = styled(MuiListItemAvatar)({
  minWidth: 0,
  marginRight: 12,
});

export default function SelectContent(props) {
  const [company, setCompany] = React.useState('');
  const [all_grow_setups, setAllGrowSetups] = React.useState([{name:'Kein Grow Setup',id:'0',device_type:0}]);
  const { grow_setup, setGrowSetup, device_type, setDeviceType } = useGrowSetup();
  const navigate = useNavigate();
  const fetchData = async () => {
    try {
      const response = await axios.post('/get_all_grow_setups', {}, {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + props.token,
          'Method': 'GET',
        },
      });
  
      const data = response.data;
  
      if (Array.isArray(data) && data.length > 0) {
        setAllGrowSetups(data);
  
        const localIdStr = localStorage.getItem("grow_setup");
        const localId = parseInt(localIdStr, 10);
  
        const idExists = data.some(item => item.id === localId);
        
        
  
        if (idExists) {
          setGrowSetup(localId);
          const item = data.find((entry) => entry.id === localId);
          const deviceType = item?.device_type;
          setDeviceType(deviceType);
        } else {
          setGrowSetup(data[0].id);
          const item = data.find((entry) => entry.id === data[0].id);
          const deviceType = item?.device_type;
          setDeviceType(deviceType);
        }
  
      } else {
        navigate('/grow_setup/settings');
      }
  
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const {getRootProps, getInputProps, isDragActive} = useDropzone({
    accept: 'image/*',
    onDrop: (acceptedFiles) => {
      const reader = new FileReader(acceptedFiles[0]);
      var file = ''
      reader.onload = () => {
        const binaryBuffer = new Uint8Array(reader.result);
        const formData = new FormData();
        const base64String = reader.result;

        all_grow_setups.forEach((item) => {
          if(item.id == grow_setup){
            item.avatar = base64String
          }
        });



        setAllGrowSetups(all_grow_setups);

        axios({
          method: "POST",
          url:"/upload_avatar_grow_setup",
          data: {base64String:base64String,grow_setup:grow_setup},
          headers: {
            'Access-Control-Allow-Origin': '*',
            'Accept': 'application/json',
            'Content-Type': 'application/json',

            'Method': 'POST',
          },
        })
            .then((response) => {


            }).catch((error) => {
          if (error.response) {
            console.log(error.response)
            console.log(error.response.status)
            console.log(error.response.headers)
          }
        });}
      reader.readAsDataURL(acceptedFiles[0]);

    },
  });


  const newSetup = (e) => {
    var x = 10;
    navigate('/grow_setup/new_grow_setup');
  };

  return (
    <Select
      labelId="grow-setup-select"
      id="grow-setup-select"
      value={grow_setup}
      onChange={(e) => {
        
        localStorage.setItem("grow_setup", e.target.value)
        setGrowSetup(e.target.value);
        const item = all_grow_setups.find((entry) => entry.id === e.target.value);
        const deviceType = item?.device_type;
        setDeviceType(deviceType);
      }}
      displayEmpty
      inputProps={{ 'aria-label': 'Select Grow Setup' }}
      fullWidth
      sx={{
        maxHeight: 56,
        width: 215,
        '&.MuiList-root': {
          p: '8px',
        },
        [`& .${selectClasses.select}`]: {
          display: 'flex',
          alignItems: 'center',
          gap: '2px',
          pl: 1,
        },
      }}
    >
      {all_grow_setups.map((setup, index) => (
          <MenuItem value={setup.id} key={index} onChange={(e, v) => {
            props.set_grow_setup(v);
            localStorage.setItem("grow_setup", v)
          }}>

            <ListItemAvatar>
              <Avatar alt="Sitemark web" {...getRootProps()} className="dropzone" src={setup.avatar} sx={{width: 36, height: 36}}>
                <DevicesRoundedIcon sx={{fontSize: '1rem'}}/>
              </Avatar>
            </ListItemAvatar>



            <ListItemText primary={setup.name} secondary={setup.name}/>
          </MenuItem>
      ))}
      <MenuItem value={99} key={99} onClick={newSetup}>

        <ListItemAvatar>
          <Avatar alt="Sitemark web" {...getRootProps()} className="dropzone" src={""} sx={{width: 36, height: 36}}>
            <DevicesRoundedIcon sx={{fontSize: '1rem'}}/>
          </Avatar>
        </ListItemAvatar>



        <ListItemText primary={"Hinzufügen"} secondary={""}/>
      </MenuItem>
    </Select>
  );
}
